import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import { disciplines, getProducts } from '@util/discipline'

import { PageSection } from '../../../theme/components/PageSection'
import { DisciplineVerzameling } from '../../projecten/components/DisciplineVerzameling'
import type { Project } from '../types/Project'

const headerCells = [
  { id: 'disciplineCode', numeric: false, label: 'Aangevraagde disciplines' },
  { id: 'netbeheerderCode', numeric: false, label: 'Netbeheerder' },
  { id: 'aantalObjecten', numeric: true, label: 'Objecten' },
  { id: 'processtap', numeric: false, label: 'Processtap', fixed: 150 },
  { id: 'opties', numeric: false, label: '', fixed: 50 },
]

interface Props {
  project: Project
}

export const DisciplineVerzamelingen = ({ project }: Props) => {
  const disciplineVerzamelingen = project.disciplineVerzamelingen || []
  const getDisciplineVerzameling = getProducts(disciplineVerzamelingen)

  return (
    <PageSection heading="Disciplines" id="disciplines">
      <Box>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>
              Alle disciplines ({disciplineVerzamelingen.length})
            </Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ padding: 0 }}>
            <Table sx={{ padding: 0, backgroundColor: '#f7f7f7' }}>
              <TableHead>
                <TableRow>
                  {headerCells.map((headerCell) => (
                    <TableCell
                      key={headerCell.id}
                      sx={{
                        width: headerCell.fixed,
                      }}
                    >
                      {headerCell.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {disciplines
                  .reduce(
                    (curr, disciplineCode) =>
                      curr.concat(getDisciplineVerzameling(disciplineCode)),
                    [],
                  )
                  .map((product: any) => {
                    return (
                      <DisciplineVerzameling
                        key={`${project.aanvraagID}${product.disciplineCode}${product.netbeheerderCode}`}
                        project={project}
                        product={product}
                      />
                    )
                  })}
              </TableBody>
            </Table>
          </AccordionDetails>
        </Accordion>
      </Box>
    </PageSection>
  )
}
